import { render } from "./FormulasPrize.vue?vue&type=template&id=0830b734"
import script from "./FormulasPrize.vue?vue&type=script&lang=js"
export * from "./FormulasPrize.vue?vue&type=script&lang=js"

import "./FormulasPrize.vue?vue&type=style&index=0&id=0830b734&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__